import React from 'react';
import styled from 'styled-components'
import { Link, useLocation } from 'react-router-dom'
import { scroller } from "react-scroll"


export const LinksArray = ({ links, onClick, toggleOpen }) => (
    Array.from(links).map((item, i) => (
      <LinkButton onClick={()=> 
        {setTimeout(()=>
          scroller.scrollTo(item.text, {
            duration: 600,
            smooth: true,
            offset: 100,
          }),200)
        toggleOpen && toggleOpen(false);
        }
      } key={i} link={item.link} color={item.color} text={item.text} />
    )
  )
)

export const LinkButton = ({ link, color, text, onClick }) => {
  let location = useLocation();

  return(
    <Link 
      onClick={onClick}
      to={`/${link}`}
      style={{textDecoration:"none"}}
    >
      <Wrapper active={location.pathname.substring(1) === link}>
        {text}
        {color && <Dot active={location.pathname.substring(1) === text} color={color} />}
      </Wrapper>
    </Link>    
  )
}

const Wrapper = styled.div(props => ({
  minHeight:108,
  fontWeight: 500,
  fontSize: "14px",
  lineHeight: "100%",
  display:"flex",
  fontStyle: "normal",
  alignItems:"center",
  cursor:"pointer",
  margin:"0px 24px",
  maxHeight:18,
  borderRadius:0,
  textDecoration:"none",
  whiteSpace: "nowrap",
  transition:"0.2s ease-in-out",
  color:!props.active ? "#949494" : "#2A2A2A",
  position:"relative",
  "@media (max-width: 650px)": {
    margin:"8px 0px",
    minHeight:"auto",
    width:110,
    marginBottom:48,
  }
}));

const Dot = styled.div(props => ({
  position:"absolute",
  top:0,
  left:0,
  height:4,
  width:4,
  background: props.color,
  opacity: props.active ? 1 : 0,
  transition: "0.2s ease-in-out",
  "@media (max-width: 650px)": {
    top:5,
    right:0,
    left:"auto",
  }
}));
